
export const actions = {
  async getCustomerCollections(){
    let customerCollections = [];
    try
    {
      const result = await this.$axios.$get(`webpos/customer-collections`);
      if(result && !result.apiMessages.hasErrors){
        customerCollections = result.value;
      }
      else{
        this.$toast.error('Error while getting customer collections');
      }
    }
    catch(e){
      this.$toast.error('Error while getting customer collections');
    }
    return customerCollections;
  }
}
